export const COST_DAY_MS = 86400000;

const pad2 = (value) => String(value).padStart(2, '0');

const asDate = (value) => value instanceof Date ? value : new Date(value);

export const toLocalDateKey = (value) => {
  const date = asDate(value);
  if (Number.isNaN(date.getTime())) return '';
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
};

export const toLocalMonthKey = (value) => {
  const date = asDate(value);
  if (Number.isNaN(date.getTime())) return '';
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}`;
};

const parseLocalDateKey = (value, endOfDay = false) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || ''));
  if (!match) return null;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = endOfDay
    ? new Date(year, month - 1, day, 23, 59, 59, 999)
    : new Date(year, month - 1, day, 0, 0, 0, 0);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
  return date.getTime();
};

const resolveMonthRange = (monthKey) => {
  const match = /^(\d{4})-(\d{2})$/.exec(String(monthKey || ''));
  if (!match) return { startTime: null, endTime: null, label: '', error: '请选择要查看的月份' };
  const year = Number(match[1]);
  const month = Number(match[2]);
  if (month < 1 || month > 12) return { startTime: null, endTime: null, label: '', error: '月份格式不正确' };
  return {
    startTime: new Date(year, month - 1, 1, 0, 0, 0, 0).getTime(),
    endTime: new Date(year, month, 0, 23, 59, 59, 999).getTime(),
    label: `${year} 年 ${month} 月`,
    error: '',
  };
};

const resolveCustomRange = (startDate, endDate) => {
  const startTime = parseLocalDateKey(startDate);
  const endTime = parseLocalDateKey(endDate, true);
  if (startTime == null || endTime == null) {
    return { startTime: null, endTime: null, label: '', error: '请选择完整的开始和结束日期' };
  }
  if (startTime > endTime) {
    return { startTime: null, endTime: null, label: '', error: '开始日期不能晚于结束日期' };
  }
  return {
    startTime,
    endTime,
    label: `${startDate} 至 ${endDate}`,
    error: '',
  };
};

const QUICK_RANGE_META = {
  '7d': { days: 7, label: '近 7 天' },
  '30d': { days: 30, label: '近 30 天' },
  '90d': { days: 90, label: '近 90 天' },
  '12m': { days: 365, label: '近 12 个月' },
  all: { days: null, label: '全部时间' },
};

export const resolveCostTimeRange = ({
  mode,
  quickRange = '30d',
  month,
  startDate,
  endDate,
  now = Date.now(),
}) => {
  if (mode === 'month') return resolveMonthRange(month);
  if (mode === 'custom') return resolveCustomRange(startDate, endDate);

  const meta = QUICK_RANGE_META[quickRange] || QUICK_RANGE_META['30d'];
  return {
    startTime: meta.days == null ? null : now - meta.days * COST_DAY_MS,
    endTime: now,
    label: meta.label,
    error: '',
  };
};
